export class User {
  id: string;
  firstName: string;
  lastName: string;
  avatar: any;
  email: string;
  isAdmin: boolean;
  isSuper: boolean;
  phoneNumber: string;
  gender: string;
  address: string;
  unitName?: string;
  dateOfBirth: string;
  createdAt: number; // Date number format
  updatedAt: number; // Date number format
  operatorId: string;

  constructor(type?: string) {
    this.id = "";
    this.firstName = "";
    this.lastName = "";
    this.email = "";
    this.avatar = "https://bit.ly/2lpilrg";
    this.phoneNumber = "";
    this.gender = "";
    this.dateOfBirth = "";
    this.isAdmin = type === "admin" ? true : false;
    this.isSuper = false;
    this.address = "";
    this.operatorId = "";
    this.createdAt = this.updatedAt = Date.now();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/user/user.ts